import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";
import { handleApiError } from "@/utils/apiErrorHandler";
import { clearError } from "./errorSlice";

interface DocumentSectionResponse {
  data: any[]; // Replace `any[]` with the actual type if known
  totalItems: number;
}

export const fetchDocumentSections = createAsyncThunk<DocumentSectionResponse>(
  "documentLibrary/fetchDocumentSections",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      dispatch(clearError());
      const response = await axios.get(`/papi/content/document-sections`);
      return response.data;
    } catch (error) {
      handleApiError(error as AxiosError, "documentLibrary", dispatch);
      return rejectWithValue(error instanceof Error ? error.message : "Failed to fetch document sections");
    }
  }
);

const documentLibrarySlice = createSlice({
  name: "documentLibrary",
  initialState: {
    documentSectionsInfo: {
      data: [] as any[], // Replace `any[]` with the actual type if known
      totalItems: 0,
    },
    loading: false,
    error: null as string | null, // Ensure error is a string or null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDocumentSections.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDocumentSections.fulfilled, (state, action) => {
        state.loading = false;
        state.documentSectionsInfo = {
          data: action.payload.data,
          totalItems: action.payload.totalItems,
        } as DocumentSectionResponse;
      })
      .addCase(fetchDocumentSections.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch document sections";
      });
  },
});

export default documentLibrarySlice.reducer;
